/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	UPDATE_AUTHENTICATED_USER(state, user) {
		localStorage.setItem('userInfo', JSON.stringify(user));
		localStorage.setItem('userRole', 'admin');
  },

  addToken: (state, payload) => state.auth = Object.assign({}, state.auth, { ...payload }),

  addUser: (state, payload) => {
    const merged = { ...payload };
    if (merged.user) {
      merged.user = { ...merged.user };
      if (merged.user.is_social_login === undefined) {
        merged.user.is_social_login = false;
      }
    }
    state.auth = { ...state.auth, ...merged };
  },

  clearSocialLoginOnTalentUser(state) {
    if (!state.auth || !state.auth.user) return;
    state.auth = {
      ...state.auth,
      user: {
        ...state.auth.user,
        is_social_login: false,
        provider_id: null,
      },
    };
  },
}